module.exports = __webpack_public_path__ + "img/album21_03.a8f242fd.jpg";